<section class="section" id="skills">
  <div class="container">
    <div class="section-head">
      <p class="eyebrow">Compétences</p>
      <h2>Stack maîtrisée et outils de production modernes</h2>
      <p class="section-sub">
        Un socle technique complet pour concevoir, livrer et maintenir des produits fiables.
      </p>
    </div>

    <div class="skills-grid">
      @for (group of groupedSkills; track group.category) {
        <article class="skills-card" appReveal>
          <h3>{{ group.category }}</h3>
          @for (skill of group.items; track skill.name) {
            <div class="skill">
              <div class="skill-icon">
                <app-icon [name]="skill.icon"></app-icon>
              </div>
              <div class="skill-meta">
                <span class="skill-name">{{ skill.name }}</span>
                @if (skill.level) {
                  <span class="skill-level">{{ skill.level }}</span>
                }
              </div>
            </div>
          }
        </article>
      }
    </div>
  </div>
</section>
